import { render } from "./InfoAccionista_Natural.vue?vue&type=template&id=400a5db9"
import script from "./InfoAccionista_Natural.vue?vue&type=script&lang=js"
export * from "./InfoAccionista_Natural.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AG\\dev\\d_7\\_work\\54\\s\\AEL.DebidaDiligencia.FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__